import React from "react";
import { Table, Collapse, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const SourceMeasurementsTable = ({ sourceMeasurements, measurementId }) => {
  if (!sourceMeasurements?.length) {
    return <p className="text-muted">No source (ogmp category) measurements available for this site.</p>;
  }

  return (
    <Table size="sm" bordered className="w-100">
      <thead>
        <tr>
          <th>Name</th>
          <th>Emissions</th>
          <th>Unit</th>
          <th>Parent Category</th>
          <th>UUID</th>
        </tr>
      </thead>
      <tbody>
        {sourceMeasurements.map((source, index) => (
          <tr key={`${measurementId}-source-${source.id || index}-${index}`}>
            <td>{source.name}</td>
            <td>{source.emissions}</td>
            <td>{source.emissionsUnit || "—"}</td>
            <td>{source.parentOgmpCategory}</td>
            <td>{source.id}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

const MeasurementDetailsPanel = ({ currentMeasurement, measurementId, isExpanded }) => {
  return (
    <tr key={`detail-${measurementId}`}>
      <td colSpan="9" className="p-0">
        <Collapse in={isExpanded === true}>
          <div className="p-3 bg-light w-100">
            <h6 className="mb-3">
              Source Measurements ({currentMeasurement.sourceMeasurements?.length || 0})
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id={`tooltip-${measurementId}`} className="text-start">
                    You can assign sources (ogmp categories) to group versions in the Projects tab.
                  </Tooltip>
                }
              >
                <span style={{ cursor: "pointer", marginLeft: "5px" }}>
                  <FontAwesomeIcon icon={faInfoCircle} className="text-primary" style={{ fontSize: "16px" }} />
                </span>
              </OverlayTrigger>
            </h6>

            <SourceMeasurementsTable sourceMeasurements={currentMeasurement.sourceMeasurements} measurementId={measurementId} />

            <div className="mt-3">
              <strong>Coordinates:</strong> {currentMeasurement.coordinates ? currentMeasurement.coordinates.join(", ") : ""}
              <br />
              <strong>OGMP Versions:</strong>{" "}
              {currentMeasurement.ogmpVersions?.length > 0 ? currentMeasurement.ogmpVersions.join(", ") : "None"}
            </div>
          </div>
        </Collapse>
      </td>
    </tr>
  );
};

export { MeasurementDetailsPanel };
